
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { useNavigate, useLocation } from "react-router-dom";

export function GuestContinue({ onClose }: { onClose: () => void }) {
  const { toast } = useToast();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSkip = () => {
    onClose();
    try {
      localStorage.setItem("guest_mode", "1");
    } catch {
      /* storage may be unavailable */
    }
    // Guest login behaves exactly like "Start for free": land on the Home dashboard.
    if (location.pathname === "/" || location.pathname === "/auth") {
      navigate("/dashboard", { replace: true });
    }
    toast({
      title: "Browsing as guest",
      description: "Look around freely. Sign in to join passports and earn rewards.",
    });
  };


  return (
    <Button 
      type="button" 
      variant="outline" 
      onClick={handleSkip}
      className="w-full text-foreground"
      aria-label="Continue as guest without signing in"
    >
      Continue as guest
    </Button>
  );
}
